/**
 *
 * HelpPrimitive
 *
 */

import { QuestionCircleIcon } from 'components/Icons';
import styleVars from 'cssOverrides/styleVars';
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage, MessageDescriptor } from 'react-intl';
import styled from 'styled-components';
import { DocsPath } from 'utils/docsURLs';
import WithPopover from '../CbPopover';
import messages from './messages';

const QuestionIconWrapper = styled(QuestionCircleIcon)`
  font-size: 1rem;
  color: ${styleVars.gray400};
  vertical-align: middle;
`;

interface DocsLinkProps {
  path?: DocsPath;
  platformVersion?: string;
}

export const getDocsURL = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _path?: DocsPath,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _platformVersion?: string, // version for release notes link only
) => `https://clearblade.atlassian.net/wiki/spaces/IoT`;

export const DocsLink = (props: React.PropsWithChildren<DocsLinkProps>) => {
  const { path, children, platformVersion } = props;
  return (
    <a
      target="_blank"
      href={getDocsURL(path, platformVersion)}
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
};

export const SimpleHelp: React.FC<{ msg?: MessageDescriptor; docsUrl?: DocsPath }> = (props) => {
  return (
    <HelpMe
      body={
        <div>
          <FormattedHTMLMessage {...props.msg} />
          {props.docsUrl && (
            <React.Fragment>
              &nbsp;
              <DocsLink path={props.docsUrl}>
                <FormattedMessage {...messages.clickForMoreInfo} />
              </DocsLink>
            </React.Fragment>
          )}
        </div>
      }
    />
  );
};

const HelpMe = WithPopover(QuestionIconWrapper);

export default HelpMe;
